import {
  CompanyVerificationRequestStatus,
  CompanyVerificationStatusIcon,
} from '@core/tellent-company-verification-types';

export function resolveCompanyVerificationStatusIcon(
  status: CompanyVerificationRequestStatus | undefined,
): CompanyVerificationStatusIcon | null {
  switch (status) {
    case CompanyVerificationRequestStatus.Pending:
      return { iconName: 'error', iconColor: 'colorIconWarningDefault' };
    case CompanyVerificationRequestStatus.FormSubmitted:
      return { iconName: 'info', iconColor: 'colorIconInfoDefault' };
    case CompanyVerificationRequestStatus.Rejected:
      return { iconName: 'error', iconColor: 'colorIconCriticalDefault' };
    default:
      return null;
  }
}
